import some from "lodash/some";
//const getInitialLoadComplete = (state: VerseStore): boolean => state.loading.initialLoadComplete;
export default function getInitialLoadComplete(state) {
  const hasAnyPlayback = some(state.playbackState, (value) => {
    if (value.time > 0) {
      return true;
    }
  });
  const hasExplicitLoadComplete = state.loading.initialLoadComplete;
  return hasAnyPlayback || hasExplicitLoadComplete;
}
